import { useState, useCallback } from "react"

export function useContextMenu() {
  const [isOpen, setIsOpen] = useState(false)
  const [position, setPosition] = useState({ x: 0, y: 0 })

  const openMenu = useCallback((event) => {
    event.preventDefault()
    event.stopPropagation()

    const { clientX, clientY } = event
    const { innerWidth, innerHeight } = window

    // Ajustar posición para que no se salga de la pantalla
    const menuWidth = 280
    const menuHeight = 200

    let x = clientX
    let y = clientY

    if (x + menuWidth > innerWidth) {
      x = innerWidth - menuWidth - 10
    }

    if (y + menuHeight > innerHeight) {
      y = innerHeight - menuHeight - 10
    }

    setPosition({ x, y })
    setIsOpen(true)
  }, [])

  const closeMenu = useCallback(() => {
    setIsOpen(false)
  }, [])

  return {
    isOpen,
    position,
    openMenu,
    closeMenu,
  }
}
